import { PageSectionWrapper } from "../../components/PageSectionWrapper";
import { VariantTitle } from "../../components/VariantTitle";
import { CUSTOM_PAGE_SECTION_IDS } from "./constants";
import { ParagraphSection } from "./components/ParagraphSection";
import { Container } from "../../components/Containers/Container";
import { ComponentRegistry } from "../../components/ComponentRegistry";
import { getContentBlockStyling, normalizeKeys } from "../../functions";

/*
	Depreceated - use/configure the component registry instead
*/
const COMPONENT_MAP = {
	[CUSTOM_PAGE_SECTION_IDS.PARAGRAPH_SECTION]: ParagraphSection,
};

/*
Useful for defining custom page sections - without having to create/define more types
or messily expand existing page section types.
*/
export const CustomPageSectionWrapper = ({
	headerText,
	subtitle,
	variant,
	content,
	containerType,
	mobileContainerType,
	componentId,
	formattedSectionStyles,
	sectionStyles,
	isStatic,
	id
}) => {
	const ComponentContent = COMPONENT_MAP[componentId] || null;
	const childStyles = sectionStyles ? getContentBlockStyling(sectionStyles) : formattedSectionStyles;
	const isNested = normalizeKeys(sectionStyles?.fields?.containerSpacing) === "nested";
	return (
		<PageSectionWrapper variant={variant} isNested={isNested} sectionId={id}>
			{headerText && <VariantTitle sectionId={id} title={headerText} subtitle={subtitle}  parsedClasses={formattedSectionStyles.headerStyling} />}
			{ComponentContent && <ComponentContent content={content} isStatic={isStatic} />}
			<Container containerType={containerType} mobileContainerType={mobileContainerType} sectionId={id}>
				<ComponentRegistry content={content} contentBlockStyles={childStyles} pageSectionId={id} isStatic={isStatic}/>	
			</Container>
		</PageSectionWrapper>
	);
};
